﻿$.fn.dxCtrlFileUploaderPopup = function custom_dxCtrlFileUploaderPopup(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfileuploaderpopup dx-ctrl");
        this.createInstance(new cdxCtrlFileUploaderPopup(this, option));
    }
    return this;
}

window.cdxCtrlFileUploaderPopup = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var pop = null
    function mConstruit() {
        container.empty();
        var popupContentElement = null
        if (parametre.isMobile) {
            pop = $("<div style='position:absolute;height:100%;width:100%;z-index:" + (mGetMaxZindexElement($("body")) + 1) + ";box-sizing:border-box;padding:10px;' class='dx-theme-material-typography dxpopmobile'/>").appendTo("body")
            option.popup = pop
            popupContentElement = pop
            var onvalide = option.onValide
            option.onValide = function (lstFileUrl) {
                pop.remove()
                onvalide(lstFileUrl)
            }
            $("<div/>").appendTo(popupContentElement).dxCtrlFileUploaderGeneral(option)
        } else {
            pop = container.appendTo("body").dxCtrlPopupBase({
                showTitle: false,
                fullScreen: true,
                showMaximize: false,
                height: "100%",
                width: "100%",
                maxWidth: 800,
                shading: true,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", ((parametre.isMobile) ? "0" : "10px"))
                    popupContentElement = contentElement
                },
                onShown: function (e) {
                    option.popup = e.component
                    var onvalide = option.onValide
                    option.onValide = function (lstFileUrl) {
                        pop.hide()
                        onvalide(lstFileUrl)
                    }
                    $("<div/>").appendTo(popupContentElement).dxCtrlFileUploaderGeneral(option)
                },
                onHidden: function (e) {
                    e.element.remove();
                    if (typeof option.onHidden != 'undefined') option.onHidden(e)
                },
                onContentReady: function (e) {
                    e.component.element().find(".dx-popup-title").css("border-bottom", "none");
                }
            }).dxCtrlPopupBase("instance");
            pop.show()
        }

    }

    this.hide = function () {
        if (parametre.isMobile) {
            pop.fadeIn(200, function () { pop.remove() })
        } else {
            pop.destroy()
        }
    }

    this.element = function () { return container }

    mConstruit();
}